import Vue from "vue";
import VueNotify from "vuejs-notify";
Vue.use(VueNotify); // use defaults
